import React from "react";
import PropTypes from "prop-types";
import Button from "react-bootstrap/Button";

const searchExamples = [
  {
    title: "Trending Threats",
    examples: [
      {
        location: "cloud",
        title: "GuLoader samples by threatname and file characteristics",
        query:
          "threatname:GuLoader type:PE/Exe/NSIS tag:contains-pe tag:cert-signed available:true"
      },
      {
        location: "cloud",
        title: "BruteRatel samples by threatname and file characteristics",
        query:
          "(threatname:Brutel OR threatname:BruteRatel) type:PE+/Exe size:[100000 TO 350000] available:true"
      },
      {
        location: "cloud",
        title:
          "BumbleBee loader samples by AV signatures and file characteristics",
        query:
          "(av-trendmicro:BumbleLoader OR av-microsoft:BumbleBee OR av-kaspersky:BumbleBee) type:PE+/Dll size:[500000 TO 1500000] tag:antidebugging available:true"
      },
      {
        location: "cloud",
        title: "Cisco Cyber Attack Samples by hash list",
        query:
          "hashes:[184a2570d71eedc3c77b63fd9d2a066cd025d20ceef0f75d428c6f7e5c6965f3, 2fc5bf9edcfa19d48e235315e8f571638c99a1220be867e24f3965328fe94a03, 542c9da985633d027317e9a226ee70b4f0742dcbc59dfd2d4e59977bb870058d, 61176a5756c7b953bc31e5a53580d640629980a344aa5ff147a20fb7d770b610, 753952aed395ea845c52e3037f19738cfc9a415070515de277e1a1baeff20647, 8df89eef51cdf43b2a992ade6ad998b267ebb5e61305aeb765e4232e66eaf79a, 8e5733484982d0833abbd9c73a05a667ec2d9d005bbf517b1c8cd4b1daf57190, 99be6e7e31f0a1d7eebd1e45ac3b9398384c1f0fa594565137abb14dc28c8a7f, bb62138d173de997b36e9b07c20b2ca13ea15e9e6cd75ea0e8162e0d3ded83b7, eb3452c64970f805f1448b78cd3c05d851d758421896edd5dfbe68e08e783d18] available:true"
      }
    ]
  },
  {
    title: "Potentially Undetected Threats",
    examples: [
      {
        location: "cloud",
        title: "Potential Ransomware samples",
        query:
          "tag:capability-cryptography tag:uri-onion-website type:PE* available:true"
      },
      {
        location: "cloud",
        title: "A set of MITRE ATT&CK techniques typical for infostealers",
        query:
          "attack-technique:[T1003, T1056, T1060, T1063, T1082, T1113,  T1115,  T1503] available:true"
      },
      {
        location: "cloud",
        title: "Potentially undetected infostealers",
        query:
          "tag:indicator-steal classification:[suspicious,unknown] type:PE* available:true"
      }
    ]
  },
  {
    title: "Network-Related Data",
    examples: [
      {
        location: "cloud",
        title: "Searching for Lokibot samples based on C2 URL pattern",
        query: 'uri-dynamic:"http://*.*/*/fre.php" type:PE/Exe available:true'
      }
    ]
  },
  {
    title: "General Malware Hunting",
    examples: [
      {
        location: "cloud",
        title: "IcedID & CobaltStrike samples signed with same certificate",
        query:
          "cert-thumbprint:4c6e21a6e96ea6fae6c142c2d1c919f590d9bf4e5c6b0f3ec7f9b0a38f3ce45d available:true"
      },
      {
        location: "cloud",
        title: "Emotet C2 Servers",
        query:
          "ipv4:[103.71.99.57, 103.224.241.74, 157.245.111.0, 37.44.244.177, 103.41.204.169, 64.227.55.231, 103.254.12.236] (type:PE+/Dll OR type:Document*) available:true"
      },
      {
        location: "cloud",
        title:
          "CVE-2022-35743 - MSDT Remote Code Execution Vulnerability related files",
        query: 'threatname:"CVE-2022-34713" available:true'
      }
    ]
  }
];

interface Props {
  onClick: (query: string, params: { location: string }) => void;
  limit?: number;
}

const SearchExamples = ({ onClick, limit }: Props) => (
  <div className="search-examples">
    {searchExamples
      .slice(0, limit || searchExamples.length)
      .map((section, idx) => (
        <div key={idx} className="search-examples__list-container">
          <h5 className="search-examples__list-title">{section.title}</h5>
          <ul className="search-examples__list">
            {section.examples.map(({ title, query, location }) => (
              <li key={title} className="search-examples__list-item">
                <Button
                  variant="link"
                  onClick={() => onClick(query.trim(), { location })}
                >
                  {title}
                </Button>
              </li>
            ))}
          </ul>
        </div>
      ))}
  </div>
);

SearchExamples.propTypes = {
  onClick: PropTypes.func.isRequired,
  limit: PropTypes.number
};

export default SearchExamples;
